<template>
  <section class="products">
    <h3>Produtos e SKUs</h3>
    <div class="searchProduct">
      <div class="searchProduct__tab">
        <button class="searchProduct__tablinks" @click="openFilter('filtros')">
          Filtrar e buscar produto
        </button>
      </div>

      <div class="searchProduct__tabcontent" id="filtros">
        <form>
          <div class="rows">
            <div class="colums-4">
              <label for="">ID do SKU</label>
            </div>
            <div class="colums-6">
              <input type="number" />
            </div>
          </div>
          <div class="rows">
            <div class="colums-4">
              <label for="">Código de Referência</label>
            </div>
            <div class="colums-6">
              <input type="number" />
            </div>
          </div>
          <div class="rows">
            <div class="colums-4">
              <label for="">Nome do Produto</label>
            </div>
            <div class="colums-6">
              <input type="text" />
            </div>
          </div>
          <div class="rows">
            <div class="colums-4">
              <label for="">Categoria</label>
            </div>
            <div class="colums-6">
              <select name="" id="">
                <option v-for="cat in categorias" :key="cat.valor" value="">
                  {{ cat.valor }}
                </option>
              </select>
            </div>
          </div>
          <div class="rows">
            <div class="colums-4">
              <label for="">Status</label>
            </div>
            <div class="colums-6">
              <select name="" id="">
                <option value="todos">Todos</option>
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </select>
            </div>
          </div>
          <button>Filtrar</button>
        </form>
      </div>
    </div>

    <div class="listProducts" style="overflow-x: auto">
      <table>
        <thead>
          <tr>
            <th>Imagem</th>
            <th>Descrição</th>
            <th>Categoria</th>
            <th>Marca</th>
            <th>Ativo</th>
            <th>Editar</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <img
                src="https://multiar.vteximg.com.br/arquivos/ids/198427_3/Ar-Condicionado-Split-Cassete-Carrier-BTUs-So-Frio-220V-Trifasico.jpg"
                alt=""
              />
            </td>
            <td>
              Ar-Condicionado Split HW Springer Midea MAXIFLEX 9.000 BTUs Só
              Frio 220V
            </td>
            <td>Split</td>
            <td>Maxiflex</td>
            <td>Sim</td>
            <td><button>Alterar</button></td>
          </tr>
          <tr>
            <td>
              <img
                src="https://multiar.vteximg.com.br/arquivos/ids/198427_3/Ar-Condicionado-Split-Cassete-Carrier-BTUs-So-Frio-220V-Trifasico.jpg"
                alt=""
              />
            </td>
            <td>
              Ar-Condicionado Split HW Springer Midea MAXIFLEX 9.000 BTUs Só
              Frio 220V
            </td>
            <td>Split</td>
            <td>Maxiflex</td>
            <td>Sim</td>
            <td><button>Alterar</button></td>
          </tr>
          <tr>
            <td>
              <img
                src="https://multiar.vteximg.com.br/arquivos/ids/198427_3/Ar-Condicionado-Split-Cassete-Carrier-BTUs-So-Frio-220V-Trifasico.jpg"
                alt=""
              />
            </td>
            <td>
              Ar-Condicionado Split HW Springer Midea MAXIFLEX 9.000 BTUs Só
              Frio 220V
            </td>
            <td>Split</td>
            <td>Maxiflex</td>
            <td>Sim</td>
            <td><button>Alterar</button></td>
          </tr>
          <tr>
            <td>
              <img
                src="https://multiar.vteximg.com.br/arquivos/ids/198427_3/Ar-Condicionado-Split-Cassete-Carrier-BTUs-So-Frio-220V-Trifasico.jpg"
                alt=""
              />
            </td>
            <td>
              Ar-Condicionado Split HW Springer Midea MAXIFLEX 9.000 BTUs Só
              Frio 220V
            </td>
            <td>Split</td>
            <td>Maxiflex</td>
            <td>Sim</td>
            <td><button>Alterar</button></td>
          </tr>
          <tr>
            <td>
              <img
                src="https://multiar.vteximg.com.br/arquivos/ids/198427_3/Ar-Condicionado-Split-Cassete-Carrier-BTUs-So-Frio-220V-Trifasico.jpg"
                alt=""
              />
            </td>
            <td>
              Ar-Condicionado Split HW Springer Midea MAXIFLEX 9.000 BTUs Só
              Frio 220V
            </td>
            <td>Split</td>
            <td>Maxiflex</td>
            <td>Sim</td>
            <td><button>Alterar</button></td>
          </tr>
          <tr>
            <td>
              <img
                src="https://multiar.vteximg.com.br/arquivos/ids/198427_3/Ar-Condicionado-Split-Cassete-Carrier-BTUs-So-Frio-220V-Trifasico.jpg"
                alt=""
              />
            </td>
            <td>
              Ar-Condicionado Split HW Springer Midea MAXIFLEX 9.000 BTUs Só
              Frio 220V
            </td>
            <td>Split</td>
            <td>Maxiflex</td>
            <td>Sim</td>
            <td><button>Alterar</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      categorias: [],
    };
  },
  methods: {
    async getDados() {
      try {
        const response = await axios.get(
          "https://www.leverosintegra.com.br/MAP/api/ProdutoLista?tipo=Categoria&token=EB973B79-477A-4F62-AD73-A96E00BFB269"
        );

        this.categorias = response.data;

      } catch (error) {
        console.log(error);
      }
    },
    openFilter(value) {
      var i, tabcontent;
      tabcontent = document.getElementsByClassName("searchProduct__tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      document.getElementById(value).classList.toggle("active");
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.active {
  display: block !important;
}
.products {
  max-width: 90%;
  margin: 0 auto;
  padding: 40px 0 20px 0;

  @media (min-width: 801px) {
    max-width: 85%;
  }

  h3 {
    color: var(--standardGreen);
  }
}

.searchProduct {
  padding-top: 30px;

  &__tablinks {
    border: 1px solid var(--customGray-100);
    border-radius: 5px 5px 0 0;
    color: var(--customGray-500);
    padding: 5px 20px;
    width: 100%;
    text-align: left;
    outline: none;

    @media (min-width: 801px) {
      width: 55%;
    }
  }

  &__tabcontent {
    display: none;
    border: 1px solid var(--customGray-100);
    padding: 10px 20px;
    color: var(--customGray-500);
    width: 100%;

    @media (min-width: 801px) {
      width: 55%;
    }

    form {
      input,
      select {
        border: 1px solid var(--customGray-200);
        color: var(--customGray-500);
        border-radius: 5px;
        outline: none;
        padding: 3px 15px;
        font-size: 0.95rem;
        max-width: 100%;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      label {
        font-size: 0.95rem;
      }

      button {
        margin-top: 20px;
        width: 30%;
        background: var(--standardGreen);
        color: var(--customWhite);
        border-radius: 5px;
        padding: 5px;
        outline: none;
      }
    }
  }
}

.listProducts {
  margin-top: 60px;

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    thead {
      tr {
        th {
          text-align: center;
          border-bottom: 1px solid var(--customGray-100);
          padding: 0 0 10px 0;
          color: var(--standardGreen);
          font-size: 0.95rem;

          &:nth-child(2) {
            width: 60%;
          }
        }
      }
    }

    tbody {
      tr {
        &:hover {
          background: var(--customGray-50);
        }
        td {
          padding: 10px 20px;
          border-bottom: 1px solid var(--customGray-100);
          font-size: 0.95rem;
          color: var(--customGray-500);
          text-align: center;

          button {
            background: var(--customBlue);
            border-radius: 5px;
            color: var(--customGray-800);
            padding: 10px;
          }
        }
      }
    }
  }
}

.rows {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.colums-4 {
  width: 30%;

  @media (min-width: 441px) {
    width: 40%;
  }
}

.colums-6 {
  width: 70%;

  @media (min-width: 441px) {
    width: 60%;
  }
}
</style>